import { IconButton, NavThirdLevelButton } from "bimui";
import './index.less';
import { ReactComponent as RectangleSvg } from 'bimui/dist/c1/icons/rectangle.svg';
import { ReactComponent as SplineCurveSvg } from 'bimui/dist/c1/icons/spline-curve.svg';
import { ReactComponent as PointSvg } from 'bimui/dist/c1/icons/point.svg';
import { ReactComponent as LineSvg } from 'bimui/dist/c1/icons/line.svg';
import { ReactComponent as PlineSvg } from 'bimui/dist/c1/icons/pline.svg';
import { ReactComponent as CircleSvg } from 'bimui/dist/c1/icons/circle.svg';
import { ReactComponent as ArcSvg } from 'bimui/dist/c1/icons/arc.svg';
import { ReactComponent as EllipseSvg } from 'bimui/dist/c1/icons/ellipse.svg';
import { ReactComponent as PieceSvg } from 'bimui/dist/c1/icons/piece.svg';
import { ReactComponent as GroupSvg } from 'bimui/dist/c1/icons/group.svg';
import { ReactComponent as MapLabelSvg } from 'bimui/dist/c1/icons/map-label.svg';
import { ReactComponent as SurfaceSvg } from 'bimui/dist/c1/icons/surface.svg';
import { ReactComponent as ExtrudedSurfaceSvg } from 'bimui/dist/c1/icons/extruded-surface.svg';
import { ReactComponent as SphereSvg } from 'bimui/dist/c1/icons/sphere.svg';
import { ReactComponent as LineEnclosedSurfaceSvg } from 'bimui/dist/c1/icons/line-enclosed-surface.svg';
import { ReactComponent as PointEnclosedSurfaceSvg } from 'bimui/dist/c1/icons/point-enclosed-surface.svg';
import { ReactComponent as BoxSvg } from 'bimui/dist/c1/icons/box.svg';
import { ReactComponent as CylinderSvg } from 'bimui/dist/c1/icons/cylinder.svg';
import { ReactComponent as RingSvg } from 'bimui/dist/c1/icons/ring.svg';
import { ReactComponent as ConeSvg } from 'bimui/dist/c1/icons/cone.svg';
import { ReactComponent as PyramidSvg } from 'bimui/dist/c1/icons/pyramid.svg';
import { ReactComponent as FrustumSvg } from 'bimui/dist/c1/icons/frustum.svg';
import { ReactComponent as WedgeSvg } from 'bimui/dist/c1/icons/wedge.svg';
import { ReactComponent as ExtrudedBodySvg } from 'bimui/dist/c1/icons/extruded-body.svg';
import { ReactComponent as DropdownSvg } from 'bimui/dist/c1/icons/dropdown.svg';

interface IProps {
    emitCommand: (command: string) => void
}

export default function SystemLibGeoBar(props: IProps) {

    const { emitCommand } = props

    return (
        <div className="system-lib-geo">
            <div className="main-tool">
                <NavThirdLevelButton icon={<RectangleSvg />} onClick={() => { emitCommand('RECTANGLE') }} />
                <NavThirdLevelButton icon={<SplineCurveSvg />} />
                <NavThirdLevelButton icon={<PointSvg />} onClick={() => { emitCommand('POINT') }} />
                <NavThirdLevelButton icon={<LineSvg />} onClick={() => { emitCommand('LINE') }} />
                <NavThirdLevelButton icon={<PlineSvg />} />
                <NavThirdLevelButton icon={<CircleSvg />} onClick={() => { emitCommand('CIRCLE') }} />
                <NavThirdLevelButton icon={<ArcSvg />} onClick={() => { emitCommand('ARC') }} />
                <NavThirdLevelButton icon={<EllipseSvg />} onClick={() => { emitCommand('ELLIPSE') }} />
                <NavThirdLevelButton icon={<PieceSvg />} />
                <NavThirdLevelButton icon={<GroupSvg />} />
                <NavThirdLevelButton icon={<MapLabelSvg />} />
                <NavThirdLevelButton icon={<SurfaceSvg />} />
                <NavThirdLevelButton icon={<ExtrudedSurfaceSvg />} onClick={() => { emitCommand('EXTRUDE') }} />
                <NavThirdLevelButton icon={<SphereSvg />} onClick={() => { emitCommand('SPHERICAL') }} />
                <NavThirdLevelButton icon={<LineEnclosedSurfaceSvg />} />
                <NavThirdLevelButton icon={<PointEnclosedSurfaceSvg />} onClick={() => { emitCommand('REGION') }} />
                <NavThirdLevelButton icon={<BoxSvg />} onClick={() => { emitCommand('BOX') }} />
                <NavThirdLevelButton icon={<CylinderSvg />} onClick={() => { emitCommand('CYLINDER') }} />
                <NavThirdLevelButton icon={<RingSvg />} onClick={() => { emitCommand('TORUS') }} />
                <NavThirdLevelButton icon={<ConeSvg />} onClick={() => { emitCommand('CONE') }} />
                <NavThirdLevelButton icon={<PyramidSvg />} onClick={() => { emitCommand('PYRAMID') }} />
                <NavThirdLevelButton icon={<FrustumSvg />} />
                <NavThirdLevelButton icon={<WedgeSvg />} onClick={() => { emitCommand('WEDGE') }} />
                <NavThirdLevelButton icon={<ExtrudedBodySvg />} onClick={() => { emitCommand('EXTRUDE') }} />
            </div>
            <IconButton icon={<DropdownSvg />} wrapClassName="geo-more" />
        </div>
    )
}